/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function FunctionDataFromJSON(json) {
    return FunctionDataFromJSONTyped(json, false);
}
export function FunctionDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        title: json['title'],
        expression: json['expression'],
        description: json['description'],
        example: json['example'],
    };
}
export function FunctionDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        title: value.title,
        expression: value.expression,
        description: value.description,
        example: value.example,
    };
}
